import { render, staticRenderFns } from "./CBoardLeftProxy.vue?vue&type=template&id=3ae1af00&"
import script from "./CBoardLeftProxy.vue?vue&type=script&lang=ts&"
export * from "./CBoardLeftProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports